// ::: RSO_CHANGE ::: tour
import {BaseUrl} from "./Setting";

const TourRouteLabelMap = {
  home: "TourObj:home",
  organizations: "TourObj:organizations",
  groups: "TourObj:groups",
  users: "TourObj:users",
  applications: "TourObj:applications",
  providers: "TourObj:providers",
  resources: "TourObj:resources",
  roles: "TourObj:roles",
  permissions: "TourObj:permissions",
  models: "TourObj:models",
  adapters: "TourObj:adapters",
  enforcers: "TourObj:enforcers",
  tokens: "TourObj:tokens",
  sessions: "TourObj:sessions",
  products: "TourObj:products",
  payments: "TourObj:payments",
  plans: "TourObj:plans",
  pricings: "TourObj:pricings",
  subscriptions: "TourObj:subscriptions",
  sysinfo: "TourObj:sysinfo",
  syncers: "TourObj:syncers",
  webhooks: "TourObj:webhooks",
};

// ::: RSO_CHANGE ::: tour
export const TourObj = (t) => {
  return {
    home: [
      {
        title: t("TourObj:home title 1"),
        description: t("TourObj:home description 1"),
        cover: () => (
          <img
            alt="rso.png"
            src={`${BaseUrl}/files/provider/rso-logo_1185x256.png`}
          />
        ),
      },
      {
        title: t("TourObj:home title 2"),
        description: t("TourObj:home description 2"),
        id: "statistic",
      },
      {
        title: t("TourObj:home title 3"),
        description: t("TourObj:home description 3"),
        id: "echarts-chart",
      },
    ],
    webhooks: [
      {
        title: t("TourObj:webhooks title 1"),
        description: t("TourObj:webhooks description 1"),
      },
    ],
    syncers: [
      {
        title: t("TourObj:syncers title 1"),
        description: t("TourObj:syncers description 1"),
      },
    ],
    sysinfo: [
      {
        title: t("TourObj:sysinfo title 1"),
        description: t("TourObj:sysinfo description 1"),
        id: "cpu-card",
      },
      {
        title: t("TourObj:sysinfo title 2"),
        description: t("TourObj:sysinfo description 2"),
        id: "memory-card",
      },
      {
        title: t("TourObj:sysinfo title 3"),
        description: t("TourObj:sysinfo description 3"),
        id: "latency-card",
      },
      {
        title: t("TourObj:sysinfo title 4"),
        description: t("TourObj:sysinfo description 4"),
        id: "throughput-card",
      },
      {
        title: t("TourObj:sysinfo title 5"),
        description: t("TourObj:sysinfo description 5"),
        id: "about-card",
      },
    ],
    subscriptions: [
      {
        title: t("TourObj:subscriptions title 1"),
        description: t("TourObj:subscriptions description 1"),
      },
    ],
    pricings: [
      {
        title: t("TourObj:pricings title 1"),
        description: t("TourObj:pricings description 1"),
      },
    ],
    plans: [
      {
        title: t("TourObj:plans title 1"),
        description: t("TourObj:plans description 1"),
      },
    ],
    payments: [
      {
        title: t("TourObj:payments title 1"),
        description: t("TourObj:payments description 1"),
      },
    ],
    products: [
      {
        title: t("TourObj:products title 1"),
        description: t("TourObj:products description 1"),
      },
    ],
    sessions: [
      {
        title: t("TourObj:sessions title 1"),
        description: t("TourObj:sessions description 1"),
      },
    ],
    tokens: [
      {
        title: t("TourObj:tokens title 1"),
        description: t("TourObj:tokens description 1"),
      },
    ],
    enforcers: [
      {
        title: t("TourObj:enforcers title 1"),
        description: t("TourObj:enforcers description 1"),
      },
    ],
    models: [
      {
        title: t("TourObj:models title 1"),
        description: t("TourObj:models description 1"),
      },
    ],
    permissions: [
      {
        title: t("TourObj:permissions title 1"),
        description: t("TourObj:permissions description 1"),
      },
      {
        title: t("TourObj:permissions title 2"),
        description: t("TourObj:permissions description 2"),
        id: "add-button",
      },
      {
        title: t("TourObj:permissions title 3"),
        description: t("TourObj:permissions description 3"),
        id: "upload-button",
      },
    ],
    roles: [
      {
        title: t("TourObj:roles title 1"),
        description: t("TourObj:roles description 1"),
      },
    ],
    resources: [
      {
        title: t("TourObj:resources title 1"),
        description: t("TourObj:resources description 1"),
      },
      {
        title: t("TourObj:resources title 2"),
        description: t("TourObj:resources description 2"),
        id: "upload-button",
      },
    ],
    providers: [
      {
        title: t("TourObj:providers title 1"),
        description: t("TourObj:providers description 1"),
      },
      {
        title: t("TourObj:providers title 2"),
        description: t("TourObj:providers description 2"),
        id: "add-button",
      },
    ],
    organizations: [
      {
        title: t("TourObj:organizations title 1"),
        description: t("TourObj:organizations description 1"),
      },
    ],
    groups: [
      {
        title: t("TourObj:groups title 1"),
        description: t("TourObj:groups description 1"),
      },
    ],
    users: [
      {
        title: t("TourObj:users title 1"),
        description: t("TourObj:users description 1"),
      },
      {
        title: t("TourObj:users title 2"),
        description: t("TourObj:users description 2"),
        id: "upload-button",
      },
    ],
    applications: [
      {
        title: t("TourObj:applications title 1"),
        description: t("TourObj:applications description 1"),
      },
    ],
  };
};

export const TourUrlList = ["home", "organizations", "groups", "users", "applications", "providers", "resources", "roles", "permissions", "models", "adapters", "enforcers", "tokens", "sessions", "products", "payments", "plans", "pricings", "subscriptions", "sysinfo", "syncers", "webhooks"];

export function getNextUrl(pathName = window.location.pathname) {
  return TourUrlList[TourUrlList.indexOf(pathName.replace("/", "")) + 1] || "";
}

let orgIsTourVisible = true;

export function setOrgIsTourVisible(visible) {
  orgIsTourVisible = visible;
  if (orgIsTourVisible === false) {
    setIsTourVisible(false);
  }
}

export function setIsTourVisible(visible) {
  localStorage.setItem("isTourVisible", visible);
  window.dispatchEvent(new Event("storageTourChanged"));
}

// ::: RSO_CHANGE ::: tour
export function setTourLogo(t, tourLogoSrc) {
  const tourObj = TourObj(t);
  if (tourLogoSrc !== "") {
    tourObj["home"][0]["cover"] = () => (
      <img alt="rso.png" src={tourLogoSrc} />
    );

  }
}

export function getTourVisible() {
  return localStorage.getItem("isTourVisible") !== "false";
}

// ::: RSO_CHANGE ::: tour

export function getNextButtonChild(t, nextPathName) {
  if (!nextPathName) {
    return t("TourObj:finish");
  }

  const labelKey =
    TourRouteLabelMap[nextPathName] ?? "TourObj:unknown";

  return t("TourObj:goToList", {
    page: t(labelKey),
  });
}

// ::: RSO_CHANGE ::: tour
export const getSteps = (t) => {
  const path = window.location.pathname.replace("/", "");
  const tourObj = TourObj(t);
  const res = tourObj[path];
  if (res === undefined) {
    return [];
  } else {
    return res;
  }
};
